import { Box, Typography, useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { LandingButton, NunaLabel } from 'components'
import { COLORS, STEPS_DATA } from 'const'
import { motion } from 'framer-motion'
import { useDataLanding } from 'hooks'
import {
  containerVariants,
  landingButtonPrimary,
  normalTextStyle,
  stepNumber,
  stepsContainer,
} from 'styles'

export const StepsSection = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const { content } = useDataLanding()

  const handleGetTitle = () => {
    const message = content?.steps?.title || 'Firma gratis tus PDFs desde '
    if (isMobile) {
      return message + 'Nuna Key'
    }
    return message
  }

  return (
    <Box
      sx={{
        backgroundColor: '#dfe3e6ff',
        px: { xs: 4, md: 15 },
        py: { xs: 8, md: 12 },
      }}
    >
      <Box
        sx={stepsContainer}
        component={motion.div}
        initial="offscreen"
        whileInView="onscreen"
        variants={containerVariants}
        viewport={{ once: true }}
      >
        <Box
          sx={{
            maxWidth: { xs: 450, md: 500, xl: 800 },
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: { xs: 'center', md: 'flex-start' },
          }}
        >
          <Typography
            variant="h3"
            sx={{
              fontFamily: 'Poppins',
              fontWeight: 600,
              textAlign: { xs: 'center', md: 'left' },
              width: { xs: '100%', md: '90%', lg: '80%' },
              fontSize: 'clamp(2rem, calc(1.5rem + 2vw), 3rem)',
            }}
          >
            {handleGetTitle()}
          </Typography>

          {!isMobile && (
            <NunaLabel
              sxTextProps={{
                fontSize: '3.5rem',
              }}
            />
          )}

          <Box sx={{ display: { xs: 'none', md: 'block' } }}>
            <LandingButton
              text={content?.steps?.buttonText || 'COMIENZA GRATIS'}
              style={{
                ...landingButtonPrimary,
                backgroundColor: COLORS.button.second,
                borderRadius: 50,
                mt: 4,
                px: 4,
                py: 1,
                width: { xs: 450, md: 400, xl: 400 },
              }}
              onClick={() =>
                window.open(
                  process.env.REACT_APP_NUNA_PROCESS_ONBOARDING || content?.steps?.buttonLink,
                  '_blank'
                )
              }
            />
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            gap: { xs: 2, md: 5, xl: 1 },
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: { xs: 2, md: 5, lg: 15, xl: 5 },
              width: '100%',
              maxWidth: { xs: '100%', md: '80%', lg: '85%', xl: '100%' },
            }}
          >
            {STEPS_DATA.map((step, index) => (
              <Box
                key={index}
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', md: 'row' },
                  alignItems: 'center',
                  justifyContent: { xs: 'center', md: 'space-between' },
                  gap: { xs: 2, md: 2, lg: 3 },
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: { xs: 'space-between', md: 'flex-start' },
                    alignItems: 'center',
                    gap: { xs: 3, lg: 4 },
                    flex: 1,
                    width: '100%',
                    minHeight: { xs: 'auto', md: '80px' },
                  }}
                >
                  <Box sx={{ ...stepNumber, backgroundColor: step.color }}>{step.number}</Box>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      flex: 2,
                      minHeight: { xs: 'auto', md: '60px' },
                    }}
                  >
                    <Typography
                      sx={{
                        ...normalTextStyle,
                      }}
                    >
                      {step.text}
                    </Typography>
                  </Box>
                </Box>

                <Box
                  component="img"
                  src={step.image}
                  alt={`Paso ${step.number}`}
                  sx={{
                    width: { xs: 180, lg: 200 },
                    height: 'auto',
                  }}
                />
              </Box>
            ))}
          </Box>

          <Box sx={{ display: { xs: 'block', md: 'none' }, mt: 2 }}>
            <LandingButton
              text={content?.steps?.buttonText || 'COMIENZA GRATIS'}
              style={{
                ...landingButtonPrimary,
                borderRadius: 50,
                px: 4,
                py: 1,
                width: 'fit-content',
              }}
              onClick={() =>
                window.open(
                  process.env.REACT_APP_NUNA_PROCESS_ONBOARDING || content?.steps?.buttonLink,
                  '_blank'
                )
              }
            />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
